import React from 'react'
import { css } from '@emotion/core'
import { boolAttr } from '@fs/zion-frontend-friends'

const socialRowCss = css`
  display: flex;
  &:not([is-mobile]) > * + * {
    margin-left: 16px;
  }

  &[is-mobile] {
    width: fit-content;
    margin: auto;
  }
`

export default function SocialRow({ isMobile, children }) {
  return (
    <div css={socialRowCss} is-mobile={boolAttr(isMobile)}>
      {children}
    </div>
  )
}
